import {
  route,
} from '@app/Routing/helpers'

const OrderList = () => import('@app/Staff/Order/List')
const OrderDetails = () => import('@app/Staff/Order/Details/OrderDetails')

const ORDER_LIST = 'orders/'
const ORDER_DETAILS = 'orders/details/:id/'

export const ORDERS_LIST_NAME = 'user:orders'
export const ORDERS_DETAILS_NAME = 'user:order'

export function createRoutes() {
  return [
    route(ORDER_LIST, OrderList, ORDERS_LIST_NAME, {
    }),
    route(ORDER_DETAILS, OrderDetails, ORDERS_DETAILS_NAME, {
      props: true
    }),
    // route(BASE, AddressBookBase, ADDRESS_BOOK_BASE_NAME, {
    //   meta: { hideVisitCard: true },
    //   redirect: { name: ADDRESS_BOOK_LIST_NAME },
    //   children: [
    //   ],
    // }),
  ]
}
